import { render } from "./MetaGoals.vue?vue&type=template&id=9e388a78&scoped=true"
import script from "./MetaGoals.vue?vue&type=script&lang=js"
export * from "./MetaGoals.vue?vue&type=script&lang=js"

import "./MetaGoals.vue?vue&type=style&index=0&id=9e388a78&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e388a78"]])

export default __exports__